import './Result.css';

type ResultProps = { files: FileObject[] }

function Result(props: ResultProps) {
  return (
    <div className="Result">
      <p>以下のファイルの送信が完了しました。</p>
      <p>ありがとうございました。</p>
      <ul>{props.files.map((file) => <li key={file.name}>{file.name}</li> )}</ul>
    </div>
  );
}

export default Result;
